/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseVideoFieldType } from './DatabaseVideoFieldType';
import {
    DatabaseVideoFieldTypeFromJSON,
    DatabaseVideoFieldTypeFromJSONTyped,
    DatabaseVideoFieldTypeToJSON,
} from './DatabaseVideoFieldType';

/**
 * 
 * @export
 * @interface DatabaseVideoField
 */
export interface DatabaseVideoField extends DatabaseField {
    /**
     * 
     * @type {DatabaseVideoFieldType}
     * @memberof DatabaseVideoField
     */
    type?: DatabaseVideoFieldType;
}

/**
 * Check if a given object implements the DatabaseVideoField interface.
 */
export function instanceOfDatabaseVideoField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseVideoFieldFromJSON(json: any): DatabaseVideoField {
    return DatabaseVideoFieldFromJSONTyped(json, false);
}

export function DatabaseVideoFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseVideoField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseVideoFieldTypeFromJSON(json['type']),
    };
}

export function DatabaseVideoFieldToJSON(value?: DatabaseVideoField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabaseVideoFieldTypeToJSON(value.type),
    };
}

